// LIBRARIES
import styled, { css } from "styled-components";

// MISC

import {
  BORDER_RADIUS,
  COLORS,
  FONT_FAMILY,
  FONT_WEIGHT,
  MARGIN,
  SIZE,
} from "constants/variables";

//ASSETS
import cursorIcon from "assets/img/Cursor.png";

export const Button = styled.button`
  background-color: transparent;
  border: none;
  padding: 12px 16px;
  font-size: 16px;
  border-radius: ${BORDER_RADIUS.radius40};
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  position: relative;
  overflow: hidden;
  z-index: 0;
  color: ${COLORS.Yellow};
  transition: background-color 0.5s ease-in-out, color 0.5s ease-in-out;

  &:hover {
    background-color: ${COLORS.Yellow};
    color: ${COLORS.RaisinBlack};
  }

  &:hover:before {
    width: 200%;
    left: 50%;
    background-color: ${COLORS.Yellow};
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    width: 0;
    height: 100%;
    background-color: ${COLORS.Yellow};
    transition: width 0.5s ease-in-out, left 0.5s ease-in-out,
      background-color 0.5s ease-in-out;
    z-index: -1;
    transform: translateX(-50%);
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: ${COLORS.RaisinBlack};
      &:before {
        width: 200%;
        left: 50%;
        background-color: ${COLORS.RaisinBlack};
      }
    `}
`;

export const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  width: 100%;
  /* height: 100px; */
  height: 80px;
  align-items: center;
  padding: ${SIZE.max28} ${MARGIN.max80};
  position: relative;
  background-color: ${COLORS.VividAuburn};
  border-bottom-left-radius: ${BORDER_RADIUS.radius24};
  border-bottom-right-radius: ${BORDER_RADIUS.radius24};
  box-shadow: 0px 4px 10px ${COLORS.boxShadow};
  z-index: 1000 !important;
  @media (max-width: 1300px) {
    padding: ${SIZE.max28} ${MARGIN.max56};
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 8px;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
`;

export const LogoText = styled.p`
  font-family: ${FONT_FAMILY.poppins};
  color: ${COLORS.Yellow};
  white-space: pre-wrap;
  font-weight: ${FONT_WEIGHT.semiBold};
  line-height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: ${SIZE.max16};
  justify-self: flex-start;
`;

export const CenterButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  margin-left: 10px;
  @media (max-width: 1500px) {
    gap: ${SIZE.max32};
  }
  @media (max-width: 1300px) {
    gap: ${SIZE.max24};
  }
`;

export const CenterComponentWrapper = styled.div`
  height: 50px;
`;

export const Logo = styled.img`
  height: 50px;
  width: 50px;
`;

export const RightButtonsWrapper = styled.div``;

export const ButtonsBarContainer = styled.div``;
